import axios from 'axios';
import axiosInstance, { axiosInstanceV3, axiosInstanceCached } from '@/utils/axios';
import Configuration from '@/utils/configuration';
import { handleApiError, deleteDataCache, sleep } from '@/utils/helpers';

const API_HOST = Configuration.value('VUE_APP_API_HOST');

// function mergeArrays(...arrays) {
//   let jointArray = [];
//   arrays.forEach(array => {
//     jointArray = [...jointArray, ...array];
//   });
//   return [...new Set([...jointArray])];
// }

export const create = async (payload) => {
  let response = {};
  try {
    // response = await axios.post(`${API_HOST}/users`, payload);
    response = await axiosInstance.post(`/users`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const show = async (userID) => {
  let response = {};
  try {
    response = await axiosInstanceCached.get(`/users/${userID}`, {
      id: `user_show_${userID}`,
      cache: {
        ttl: 1000 * 60 * 5,
      },
    });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// // Switching out for new v3
// export const stats = async (payload) => {
//   let response = {};
//   try {
//     response = await axiosInstanceCached.get(`/users/${payload.user_id}/playerstatistics`, {
//       id: `user_stats_${payload.user_id}`,
//       cache: {
//         ttl: 1000 * 60 * 2,
//       },
//     });
//     return response;
//   } catch (error) {
//     return handleApiError(error);
//   }
// };

// @ id: user uuid
// @ deleteCache: default false. Set to true to delete cache and query fresh data
// @ type: Vales are practice or play. Default call in User to practice.
export const userClubStats = async ({ id, deleteCache = false, type = '' }) => {
  let response = {};
  await deleteDataCache(axiosInstanceCached, deleteCache, `club_stats_${id}`);
  try {
    response = await axiosInstanceCached.get(
      `/users/${id}/club-stats${type ? `?type=${type}` : ''}`,
      {
        id: `club_stats_${id}`,
        cache: {
          ttl: 1000 * 60 * 2, // 2 minutes
        },
      }
    );
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const handicapStats = async (id) => {
  let response = {};
  try {
    response = await axiosInstanceCached.get(`/users/${id}/handicap`, {
      id: `hcp_stats_${id}`,
      cache: {
        ttl: 1000 * 60 * 15,
      },
    });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const resetUserHandicap = async (userID) => {
  let response = {};
  try {
    response = await axiosInstance.get(`/users/recalculateUserHandicap?userID=${userID}`);
    await deleteDataCache(axiosInstanceCached, true, `user_show_${userID}`);
    await deleteDataCache(axiosInstanceCached, true, `hcp_stats_${userID}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const me = async () => {
  let response = {};

  try {
    response = await axiosInstance.get(`/me`);
    // response = await axiosInstanceCached.get(`/me`, {
    //   id: `me`,
    //   cache: {
    //     ttl: 1000 * 60 * 15,
    //   },
    // });
    // console.log('response:', response);
    // console.log('cached:', response.cached);
    // console.log('ttl:', response.config?.cache?.ttl);
    // console.log('config:', response.config);
    // console.log('duration:', response.duration);
    // console.log('============================');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const clubPermissions = async () => {
  let response = {};

  try {
    response = await axiosInstanceCached.get(`/user/club_permissions`, {
      id: `club_perms`,
      cache: {
        ttl: 1000 * 60 * 15, //* 15 min
      },
    });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const profileImages = async () => {
  let response = {};
  try {
    response = await axiosInstanceCached.get(`/me/profile-images`, {
      cache: {
        ttl: 1000 * 60 * 120,
      },
    });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const update = async (payload) => {
  const { userID } = payload;
  delete payload.permissions;
  let response = {};
  try {
    response = await axiosInstance.patch(`/me`, payload);
    await deleteDataCache(axiosInstanceCached, true, `user_show_${userID}`);
    await deleteDataCache(axiosInstanceCached, true, `v3_get_me`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const changePassword = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.put(`/me/password`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const resetPassword = async (data) => {
  let response = {};
  try {
    response = await axios.put(`${API_HOST}/me/password-reset`, data.payload, {
      headers: {
        Authorization: `Bearer ${data.token}`,
      },
    });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const sendActivationEmail = async () => {
  let response = {};
  try {
    response = await axiosInstance.post(`/me/activation-email`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const sendPasswordResetEmail = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/password-reset`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const activate = async (token) => {
  let response = {};
  try {
    response = await axios({
      method: 'post',
      url: `${API_HOST}/me/activate`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    // //* keep main axios to pass in token
    // response = await axios.post(`${API_HOST}/me/activate`, {
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //   },
    // });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteAccount = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/users/delete_account`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
